<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import PasswordChangeComponent from "@/components/password-change-component";
import ProfileUpdateComponent from "@/components/profile-update-component";
import {ME} from "@/gql";
// import {mapActions} from 'vuex'

/**
 * Contacts-Profile component
 */
export default {
  page: {
    title: "Profile",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {ProfileUpdateComponent, PasswordChangeComponent, Layout, PageHeader },
  data() {
    return {
      title: "Profile",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Profile",
          active: true
        }
      ],
      statData: [
        {
          icon: "bx bx-check-circle",
          title: "Completed Projects",
          value: "125"
        },
        {
          icon: "bx bx-hourglass",
          title: "Pending Projects",
          value: "12"
        },
        {
          icon: "bx bx-package",
          title: "Total Revenue",
          value: "$36,524"
        }
      ],
      user: {},
      me: {
        avatar: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        profile: {
          idNumber: "",
          kraPin: "",
          nhif: "",
          nssf: "",
          physicalAddress: "",
          poBox: "",
        }
      }
    };
  },
  apollo: {
    me: {
      query: ME
    }
  },
  async mounted() {
    this.user = await this.$store.dispatch('authentication/fetchActiveUser')
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-3">
                  <h5 class="text-primary">Welcome Back !</h5>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-sm-4">
                <div class="avatar-md profile-user-wid mb-4">
                  <img
                      :src="me.avatar"
                      alt
                      class="img-thumbnail rounded-circle"
                  />
                </div>
                <h5 class="font-size-15 text-truncate">{{ me.firstName }} {{me.lastName}}</h5>
                <p class="mb-0 text-truncate text-success">Role</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>
    <div class="row">
      <div class="col-xl-7">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Personal Information</h4>
            <div class="table-responsive">
              <profile-update-component :userDetails="me"/>
            </div>
          </div>
        </div>
        <!-- end card -->

<!--        <div class="card">-->
<!--          <div class="card-body">-->
<!--            <h4 class="card-title mb-4">Authentication Sessions</h4>-->
<!--            <div class="table-responsive">-->
<!--              <table class="table table-nowrap table-hover mb-0">-->
<!--                <thead>-->
<!--                <tr>-->
<!--                  <th scope="col">#</th>-->
<!--                  <th scope="col">Location</th>-->
<!--                  <th scope="col">Last login Attempt</th>-->
<!--                </tr>-->
<!--                </thead>-->
<!--                <tbody>-->
<!--                <tr>-->
<!--                  <th scope="row">-->
<!--                    <div class="me-3">-->
<!--                      <i class="bx bx-server h4 text-warning"></i>-->
<!--                    </div>-->
<!--                  </th>-->
<!--                  <td>Skote admin UI</td>-->
<!--                  <td>2 Sep, 2019</td>-->
<!--                </tr>-->

<!--                <tr>-->
<!--                  <th scope="row">-->
<!--                    <div class="me-3">-->
<!--                      <i class="bx bx-server h4 text-warning"></i>-->
<!--                    </div>-->
<!--                  </th>-->
<!--                  <td>Skote admin Logo</td>-->
<!--                  <td>1 Sep, 2019</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <th scope="row">-->
<!--                    <div class="me-3">-->
<!--                      <i class="bx bx-server h4 text-warning"></i>-->
<!--                    </div>-->
<!--                  </th>-->
<!--                  <td>Redesign - Landing page</td>-->
<!--                  <td>21 Sep, 2019</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <th scope="row">-->
<!--                    <div class="me-3">-->
<!--                      <i class="bx bx-server h4 text-warning"></i>-->
<!--                    </div>-->
<!--                  </th>-->
<!--                  <td>App Landing UI</td>-->
<!--                  <td>29 Sep, 2019</td>-->
<!--                </tr>-->
<!--                </tbody>-->
<!--              </table>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <!-- end card -->
      </div>

      <div class="col-xl-5">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Password Change</h4>
            <password-change-component/>
          </div>
        </div>


      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
